const API_ROOT = 'https://api.bentobento.info';
const SOCKET_ROOT = 'https://api.bentobento.info/admin-backend';
const BENTO_URL = 'https://bentobento.info';
const GA_MEASUREMENT_ID = 'G-N2949D1VBG';
const ENABLE_REPORT_IMPROVEMENTS = false;
const ENABLE_SURVEY_WIZARD = true;

export {
  API_ROOT,
  BENTO_URL,
  ENABLE_REPORT_IMPROVEMENTS,
  ENABLE_SURVEY_WIZARD,
  GA_MEASUREMENT_ID,
  SOCKET_ROOT,
};
